import { fetchCatalogExercises, type Exercise } from "@jackedlogs/shared";

import { apiFetch } from "../api";
import { lsCache } from "../lsCache";

// web-rnw's LoggerCatalogAdapter (RW-18 hostDeps.ts) — the localStorage twin
// of apps/mobile/src/state/exercisesCache.ts's AsyncStorage mirror. Same
// cache-first-then-SWR shape the Logger's useLoggerCatalog always had; only
// the storage adapter changes (lsCache instead of AsyncStorage — web has no
// AsyncStorage in the bundle). The fetch itself (paged read, per-row
// validation, EN-name ordering) is the SAME @jackedlogs/shared
// fetchCatalogExercises mobile's mirror wraps — no second implementation.

const cache = lsCache<Exercise[]>("logger/exercisesCache.v1");

export async function loadCachedExercises(): Promise<Exercise[] | null> {
  return cache.read();
}

export async function fetchAndPersistExercises(): Promise<Exercise[]> {
  const items = await fetchCatalogExercises(apiFetch);
  await cache.write(items);
  return items;
}
